import { Party } from "../models/party"
import { FacilityLocation, ProviderLocationIdentifier } from "./facility";

export interface IAppointment
{
    id: number;
    appointmentDate: Date;
    providerLocation: FacilityLocation;
    status: number;
    person: Party;
}

export class Appointment implements IAppointment
{
    constructor
    (
        public id: number,
        public appointmentDate: Date,
        public providerLocation: FacilityLocation,
        public status: number,
        public statusName: string,
        public person: Party
    )
    {

    }

}

export class AppointmentInsert
{
    constructor
    (
        public appointmentDate: Date,
        public providerLocationId: ProviderLocationIdentifier
    )
    {

    }
}

export class AppointmentUpdate
{
    constructor
    (
        public appointmentId: number
    )
    {

    }
    appointmentDate? : Date;
    providerLocationId?: ProviderLocationIdentifier;
    appointmentStatus?: number;

}

